import React, { useState, useEffect } from "react";
import axios from "axios";
import GetDistricts from "../../Dropdowns/getDistricts";
import BankApprovalTable from "../BankDetailsApproval/BankApprovalTable";
import MissingBankDetailsModal from "../BankDetailsApproval/MissingBankDetailsModal";

axios.defaults.withCredentials = true;
const API_URL = process.env.REACT_APP_URL;
const API_URL_FPS = process.env.REACT_APP_URL_HEADER;

const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"];

export default function BankApproval() {
    const [state, setState] = useState({
        selectedDistrict: "", districtName: "", selectedMonth: null, selectedYear: null, reportMonth: null,
        reportYear: null, currentMonth: null, currentYear: null, prevMonth: null, prevYear: null,
        isMonthClosed: false, records: [], loading: false, showTable: false
    });

    const [selectedIds, setSelectedIds] = useState([]);
    const [showRejectModal, setShowRejectModal] = useState(false);
    const [rejectRemark, setRejectRemark] = useState("");
    const [showMissingModal, setShowMissingModal] = useState(false);
    const [missingList, setMissingList] = useState([]);

    useEffect(() => {
        const init = async () => {
            try {
                const [mRes, yRes] = await Promise.all([
                    axios.get(`${API_URL_FPS}/Common/currentMonth`),
                    axios.get(`${API_URL_FPS}/Common/currentYear`)
                ]);

                const curM = mRes.data;
                const curY = yRes.data;

                const prevM = curM === 1 ? 12 : curM - 1;
                const prevY = curM === 1 ? curY - 1 : curY;

                const prev2M =
                    curM === 1 ? 11 :
                        curM === 2 ? 12 :
                            curM - 2;

                const prev2Y =
                    curM === 1 || curM === 2 ? curY - 1 : curY;

                setState(s => ({
                    ...s,
                    currentMonth: curM,
                    currentYear: curY,
                    prevMonth: prevM,
                    prevYear: curY - 1,
                    nextYear: curY + 1,
                    prev2Month: prev2M,
                    prev2Year: prev2Y,
                    selectedMonth: curM,
                    selectedYear: curY
                }));
            } catch (err) {
                alert("Failed to load current month/year");
            }
        };

        init();
    }, []);


    const actionableRecords = state.records.filter(r => r.showCheckbox);
    const hasPendingForAction = actionableRecords.length > 0;
    const allPendingFpsIds = actionableRecords.map(r => r.fpsId);
    const allChecked = allPendingFpsIds.length > 0 && allPendingFpsIds.every(id => selectedIds.includes(id));
    const someChecked = selectedIds.length > 0 && selectedIds.length < allPendingFpsIds.length;

    const toggleAll = () => setSelectedIds(allChecked ? [] : [...allPendingFpsIds]);
    const toggleOne = (id) => setSelectedIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);

    const handleShowRecords = async () => {
        if (!state.selectedDistrict) return alert("Please select a district.");
        setState(s => ({
            ...s, loading: true, showTable: false,
            reportMonth: s.selectedMonth,
            reportYear: s.selectedYear
        }));
        try {
            const res = await axios.get(`${API_URL}/api/bank/load`, {
                params: { district: state.selectedDistrict, month: state.selectedMonth, year: state.selectedYear },
                withCredentials: true
            });
            setState(s => ({
                ...s,
                districtName: res.data.districtName || state.selectedDistrict,
                isMonthClosed: res.data.isMonthClosed || false,
                records: res.data.records || [],
                loading: false,
                showTable: true
            }));
            setSelectedIds([]);
        } catch (err) {
            alert(err.response?.data?.error || "Failed to load records");
            setState(s => ({ ...s, loading: false, showTable: false }));
        }
    };

    const performAction = async (action) => {
        let idsToSend = action === "close_month" ? allPendingFpsIds : selectedIds;
        if (action !== "close_month" && idsToSend.length === 0) return alert("Please select at least one record.");

        if (action === "approve" && !window.confirm("Approve selected records?")) return;
        if (action === "reject" && !rejectRemark) return alert("Please select a remark.");

        const payload = {
            action, fpsIds: idsToSend.map(String), district: state.selectedDistrict,
            month: state.selectedMonth, year: state.selectedYear,
            ...(action === "reject" && { remark: rejectRemark })
        };

        try {
            const res = await axios.post(`${API_URL}/api/bank/action`, payload, { withCredentials: true });
            alert(res.data.message || "Success!");
            setShowRejectModal(false); setRejectRemark(""); setSelectedIds([]);
            handleShowRecords();
        } catch (err) {
            alert(err.response?.data?.error || "Server error");
        }
    };

    const handleCloseMonth = async () => {
        try {
            const res = await axios.post(`${API_URL}/api/bank/validate-close`, null, {
                params: {
                    district: state.selectedDistrict,
                    month: state.selectedMonth,
                    year: state.selectedYear
                },
                withCredentials: true
            });

            if (res.data.status === "OK") {
                if (window.confirm(`Close month for ${state.districtName || state.selectedDistrict}?\nThis will freeze all bank approvals for this month.`)) {
                    await axios.post(`${API_URL}/api/bank/action`, {
                        action: "close_month",
                        fpsIds: [],
                        district: state.selectedDistrict,
                        month: state.selectedMonth,
                        year: state.selectedYear
                    }, { withCredentials: true });

                    alert("Month closed successfully!");
                    handleShowRecords();
                }
            } else {
                setMissingList(res.data.list || []);
                setShowMissingModal(true);
            }
        } catch (err) {
            alert(err.response?.data?.error || "Failed to close month");
        }
    };

    return (
        <>
            <table width="50%" align="center" cellPadding="8" cellSpacing="0" style={{ marginTop: "20px", border: "1px solid #000", fontFamily: "Arial" }}>
                <tbody>
                    <tr style={{ backgroundColor: "#000", color: "white" }}>
                        <th colSpan="7" >Bank Details Approval</th>
                    </tr>
                    <tr>
                        <td><strong>District:</strong></td>
                        <td><GetDistricts onChange={(code) => setState(s => ({ ...s, selectedDistrict: code }))} onLoadingChange={() => { }} /></td>
                        <td><strong>Month:</strong></td>
                        <td>
                            <select
                                value={state.selectedMonth || ""}
                                onChange={e => setState(s => ({ ...s, selectedMonth: +e.target.value }))}
                            >
                                <option value="">Select Month</option>
                                {monthNames.map((name, index) => (
                                    <option key={index + 1} value={index + 1}>
                                        {name}
                                    </option>
                                ))}
                            </select>


                        </td>
                        <td>
                            <select
                                value={state.selectedYear || ""}
                                onChange={e => setState(s => ({ ...s, selectedYear: +e.target.value }))}
                            >
                                <option value="">Select Year</option>

                                <option value={state.prevYear}>{state.prevYear}</option>
                                <option value={state.currentYear}>{state.currentYear}</option>
                                <option value={state.nextYear}>{state.nextYear}</option>
                            </select>

                        </td>

                        <td>
                            <button onClick={handleShowRecords} disabled={state.loading}
                                className="button button2" >
                                {state.loading ? "Loading..." : "Submit"}
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

            {state.showTable && (
                <BankApprovalTable
                    state={state}
                    selectedIds={selectedIds}
                    toggleAll={toggleAll}
                    toggleOne={toggleOne}
                    allChecked={allChecked}
                    someChecked={someChecked}
                    hasPendingForAction={hasPendingForAction}
                    performAction={performAction}
                    handleCloseMonth={handleCloseMonth}
                    setShowRejectModal={setShowRejectModal}
                />
            )}

            {showRejectModal && (
                <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.8)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999 }}>
                    <div style={{ background: "white", padding: "30px", borderRadius: "10px", width: "400px", textAlign: "center" }}>
                        <h3>Select Rejection Remark</h3>
                        <select value={rejectRemark} onChange={e => setRejectRemark(e.target.value)} style={{ width: "100%", padding: "12px", margin: "15px 0" }}>
                            <option value="">Select Remark</option>
                            <option>Invalid IFSC CODE</option>
                            <option>Invalid PAN NO.</option>
                            <option>Invalid Acc. NO.</option>
                            <option>Others</option>
                        </select>
                        <button onClick={() => performAction("reject")} disabled={!rejectRemark}
                            style={{ padding: "12px 30px", background: "#cc0000", color: "white", border: "none", margin: "0 10px" }}>
                            Confirm
                        </button>
                        <button onClick={() => { setShowRejectModal(false); setRejectRemark(""); }}
                            style={{ padding: "12px 30px", background: "#666", color: "white", border: "none" }}>
                            Cancel
                        </button>
                    </div>
                </div>
            )}

            <MissingBankDetailsModal
                show={showMissingModal}
                onClose={() => setShowMissingModal(false)}
                list={missingList}
                districtName={state.districtName}
            />

            <br></br>
            <br></br>
            <br></br>
            <br></br>

        </>
    );
}